export default __webpack_public_path__ + "static/media/mobileWef5.c7124cdb.png";